import { render, staticRenderFns } from "./RDataCard.vue?vue&type=template&id=d687578e&scoped=true&"
import script from "./RDataCard.vue?vue&type=script&lang=js&"
export * from "./RDataCard.vue?vue&type=script&lang=js&"
import style0 from "./RDataCard.vue?vue&type=style&index=0&id=d687578e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d687578e",
  null
  
)

export default component.exports